import { Link, Box, Text } from '@redriverpress/system'

export default function Footer({ color, ...props }) {
  return (
    <Box
      fontSize={0}
      display='flex'
      justifyContent={[null, null, null, 'center']}
      {...props}
    >
      <Link color={color} href='/terms'>
        Terms of Use
      </Link>
      <Text color={color} px={3}>
        &bull;
      </Text>
      <Link color={color} href='/privacy'>
        Privacy Policy
      </Link>
    </Box>
  )
}

Footer.defaultProps = {
  color: 'gray800',
}
